export default __webpack_public_path__ + "static/media/wi_50d_mist.b16bf00d.svg";